import ShippingAndOtherOffer from '../ShippingAndOtherOffer';
import {
  ReplacedProduct,
  SelectionT,
} from '@/lib/collections/catalogue/helpers';
import { DeliveryDateResponse } from '@/api/products/delivery-date';
import { ExpressShippingShopifyOfferResponse } from '@/api/express-shipping/offer';
import { DispatchType } from '@/lib/use-vendor-details';
import { ShippingData } from './types';

type ShippingOptionsSectionProps = {
  offer: ReplacedProduct;
  deliveryDate: DeliveryDateResponse | undefined;
  expressShippingOffer: ExpressShippingShopifyOfferResponse | undefined;
  dispatch: DispatchType;
  purchaseLinkOffer: ReplacedProduct;
  productName: string;
  handleShippingTypeChanged: (data: ShippingData) => void;
  selection: SelectionT;
  categoryPk: string;
};

const ShippingOptionsSection = (props: ShippingOptionsSectionProps) => {
  const {
    offer,
    deliveryDate,
    expressShippingOffer,
    dispatch,
    purchaseLinkOffer,
    productName,
    categoryPk,
    handleShippingTypeChanged,
    selection,
  } = props;

  return (
    <div className="mt-4" id="shipping-options">
      <h3 className="mb-1 text-lg font-bold">Shipping options</h3>
      <ShippingAndOtherOffer
        key={offer.key}
        deliveryDate={deliveryDate}
        expressShippingOffer={expressShippingOffer}
        dispatch={dispatch}
        offer={purchaseLinkOffer}
        productName={productName}
        vendor={purchaseLinkOffer.vendor}
        onShippingTypeChanged={handleShippingTypeChanged}
        categoryPk={categoryPk}
        condition={
          offer.replacedFromCondition
            ? offer.replacedFromCondition
            : (selection.condition as string)
        }
      />
    </div>
  );
};

export default ShippingOptionsSection;
